export default "__VITE_ASSET__DJrHPWTL__"